import * as actionTypes from '../actionTypes';

const initialState = {
    lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'bg',
    isUserLogged: localStorage.getItem('id_token') ? true : false,
    isPlannerVisible: false,
    activeStep: 0
}

const commonReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LANG_CHANGE:
            return {
                ...state,
                lang: action.lang
            }
        case actionTypes.USER_LOGIN:
            return {
                ...state,
                isUserLogged: true,
            }
        case actionTypes.USER_LOGOUT:
            return {
                ...state,
                isUserLogged: false
            }
        case actionTypes.PLANNER_VISIBLE:
            return {
                ...state,
                isPlannerVisible: action.isPlannerVisible
            }
        case actionTypes.SET_ACTIVE_STEP:
            return {
                ...state,
                activeStep: action.activeStep
            }
    }

    return state;
}

export default commonReducer;